module.exports = __webpack_public_path__ + "img/login2.9ab9b270.png";